import { createTracker } from 'usage-tracker';
const standaloneTracker = createTracker({
  standalone: true
});

/**
 * Utility function to track invoice usage events using standalone tracking
 */
export const trackInvoiceUsage = (properties = {}) => {
  standaloneTracker.track('Invoices Ui', 'Invoice Usage', properties);
};

/**
 * Track AI email generation usage
 */
export const trackGenerateInvoiceEmail = () => {
  trackInvoiceUsage({
    action: 'Generate invoice email'
  });
};